//Libs
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
//Modelos
import QuestionarioQuestao from '../../models/QuestionarioQuestao';
import ErroQuestionarioQuestao from '../../models/ErroQuestionarioQuestao';

/**
 * Componente para renderizar a opção de tornar a resposta obrigatória
 */
class QuestaoObrigatoria extends Component {
    constructor(props) {
        super(props);
        //Bindigs
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    }

    /**
     * Trata as alterações no checkbox
     * @param {*} event Objeto contendo os dados do vento
     */
    handleCheckboxChange(event) {
        //Não dispara a alteração se for somente leitura
        if (!this.props.readOnly) {
            //Copia o valor recebido
            const questao = QuestionarioQuestao.clone(this.props.questao);
            //Atualiza somente o valor do campo alterado
            questao.obrigatoria = event.target.checked;
            //Atualiza o estado
            if (this.props.onChange)
                this.props.onChange(questao);
        }
    }

    render() {
        const { questao, erros } = this.props;

        return (
            <Fragment>
                <Grid item xs={12} sm="auto" >
                    <FormControl fullWidth variant="standard" error={!!erros.obrigatoria} >
                        <FormControlLabel
                            id="obrigatoria-label"
                            control={
                                <Checkbox
                                    checked={questao.obrigatoria}
                                    onChange={this.handleCheckboxChange}
                                    name="obrigatoria"
                                    color="primary"
                                />
                            }
                            label="Obrigatória"
                        />
                        <FormHelperText id="obrigatoria-helper">{erros.obrigatoria}</FormHelperText>
                    </FormControl>
                </Grid>
            </Fragment>
        );
    }
}

QuestaoObrigatoria.propTypes = {
    /** Dados da questão */
    questao: PropTypes.instanceOf(QuestionarioQuestao).isRequired,
    /** Mensagens de erro da questão, referente as opções de resposta */
    erros: PropTypes.instanceOf(ErroQuestionarioQuestao),
    /** Identifica se o componente é somente leitura e não permite alterações */
    readOnly: PropTypes.bool,
    /** Evento disparado quando há alteração nas opções da questão */
    onChange: PropTypes.func
};

QuestaoObrigatoria.defaultProps = {
    erros: new ErroQuestionarioQuestao(),
    readOnly: false
};

export default QuestaoObrigatoria;